import { Component, Input, ContentChildren, QueryList, TemplateRef, AfterContentInit, AfterViewInit } from '@angular/core';
import { TemplateDirective } from '../../directives/template/template.directive';
import { LayoutTypesEnum } from '../../enums/layout-types.enum';

@Component({
    selector: 'agpr-master-layout',
    templateUrl: './master-layout.component.html',
    styleUrls: ['./master-layout.component.scss'],
    standalone: false
})
export class MasterLayoutComponent implements AfterContentInit, AfterViewInit {
    @Input() id: string;
    @Input() layout: LayoutTypesEnum = LayoutTypesEnum.horizontal;
    @Input() allowFullWidth: boolean = false;

    @ContentChildren(TemplateDirective) templates: QueryList<TemplateDirective>;

    navigationTemplate: TemplateRef<any>;
    layoutTypes: any = LayoutTypesEnum;

    ngAfterContentInit() {
        this.templates.forEach(item => {
            switch (item.getType()) {
                case 'navigation':
                    this.navigationTemplate = item.template;
                    break;

                default:
                    this.navigationTemplate = item.template;
                    break;
            }
        });
    }

    ngAfterViewInit(): void {
        (document.querySelector('.agpr-masterLayout-navigation') as HTMLElement).focus();
    }
}
